import { useScrollable } from '@klickly/front-packages';

export const usePromotionsBottomHandler = ({ handler, ref }) => {
    useScrollable(ref, null, handler);
};
